import { useCallback, useEffect, useMemo, useState } from "react";

export default useDarkModeEnabled;

function useDarkModeEnabled(): boolean {
  const darkModeMediaQuery = useMemo(
    () => window.matchMedia("(prefers-color-scheme: dark)"),
    [],
  );
  const [enabled, setEnabled] = useState(darkModeMediaQuery.matches);
  const handleChange = useCallback(({ matches }: MediaQueryListEvent) => {
    setEnabled(matches);
  }, []);
  useEffect(() => {
    darkModeMediaQuery.addEventListener("change", handleChange);
    return () => {
      darkModeMediaQuery.removeEventListener("change", handleChange);
    };
  }, [darkModeMediaQuery, handleChange]);
  return enabled;
}
